// extracted by mini-css-extract-plugin
export var wrapper = "index-module--wrapper--7Maap";
export var fadein = "index-module--fadein--2Km8X";